import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { SearchCompanyAndUser } from '../../Users/components/SearchCompanyAndUser';
import { Loader } from '../../../components/Loader';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { parseCompany } from '../../Companies/helpers';
import { companySearch } from '../../Companies/actions';
import { selectFilterSingleValue, selectFilterValues, selectCompanyFilter } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { updateCompanyFilter } from '../actions';
import { REQUEST_COMPANIES_SEARCH } from '../../Companies/constants';
import { REQUEST_USER } from '../../Users/constants';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { getPropByName } from '../../../utils/props';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  .ranged {
    min-width: ${props => (props.controlWidth ? props.controlWidth : '55%')};
  }

  min-width: ${props => (props.minWidth ? props.minWidth : '')};

  .button-filter-block {
    // position: absolute;
    top: -50px;
    left: 0px;
  }
  .selected {
    background-color: #0183d5 !important;
    color: white !important;
  }
`;
const DropdownContainer = styled.div`
  position: relative;
  width: 230px;
`;
const DropdownOptions = styled.ul`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  top: 50px;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '5px' : '0')};
  margin-top: 20px;
  background-color: white;
  max-height: 200px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#0083d5' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'white' : 'inherited')};

  &:hover {
    background-color: grey;
    color: white;
  }
`;

const STATE = {
  selectedValues: [],
  selectedValue: null,
  selectedLabels: [],
  selectedLabel: '',
  altValue: null,
  showOptions: false,
  min: null,
  max: null,
  minDate: null,
  maxDate: null,
  text: '',
  company: null,
  user: null,
  searchLabel: '',
};

/* eslint-disable react/prefer-stateless-function */
class CompanyFilterComp extends BaseComponent {
  constructor(props) {
    let filterPair = props.filter?.properties?.find(f => f.key === props.name);
    let filterValue = filterPair?.value;
    let filterLabel = filterPair?.label;
    let updateState = {};
    if (filterValue) {
      switch (props.type) {
        case 'single':
          updateState = { selectedValue: filterValue[0] ?? null, selectedLabel: filterLabel[0] ?? '' };
          break;
        case 'multiple':
          updateState = { selectedValues: filterValue ?? [], selectedLabels: filterLabel ?? [] };
          break;
      }
    }

    super(props, {
      ...STATE,
      ...updateState,
      search: props.filter?.searchString || '',
    });

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.altKey && prevState.selectedValue !== this.state.selectedValue) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        this.props.change(this.state.selectedValue, this.props.name, this.state.selectedLabel);
      }
    }
    if (this.props.altKey && prevState.altValue !== this.state.altValue) {
      if (this.state.altValue === null || this.state.altValue === '') {
        this.props.reset(true);
      } else {
        this.props.change(this.state.altValue, this.props.altKey);
      }
    }
    if (prevState.selectedValue !== this.state.selectedValue && !this.props.altKey) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        if (this.props.name === 'has_ordered') {
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel], 'has_outgoing_order');
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel], 'has_incoming_product_order');
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel], 'has_product_ordered');
        } else {
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel]);
        }
      }
    }
    if (!_.isEqual(prevState.selectedValues, this.state.selectedValues)) {
      if (!this.state.selectedValues.length) {
        this.props.reset();
      } else {
        this.props.changeValues(this.state.selectedValues, this.state.selectedLabels);
      }
    }
    if (prevState.min !== this.state.min || prevState.max !== this.state.max) {
      this.props.changeValues([this.state.min ?? '0', this.state.max ?? '0']);
    }

    if (prevState[this.props.search] !== this.state[this.props.search]) {
      this.props.changeValues([this.state[this.props.search] + ''], [this.state.searchLabel]);
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  compareLabel = (a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  };

  get options() {
    if (this.props.noModify && this.props.options?.length) {
      return this.props.options?.map(o => ({ label: o?.label, value: o?.value + '' }))?.sort(this.compareLabel);
    }
    const res = !!this.props.isBool ? [] : [{ label: `${this.lblStr('company.filter.empty')}`, value: '-' }];
    const optionsToParse = this.props.isBool
      ? ['no', 'yes']
      : this.props.search
      ? []
      : this.props.options?.sort((a, b) => {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else return 0;
        });
    return res.concat(
      optionsToParse
        ?.map(value => {
          const lbl = this.lblStr(`company.filter.${value}`) ?? '';
          return {
            label: `${lbl}` ?? value,
            value: this.props.isBool ? (value === 'yes' ? '1' : value === 'no' ? '0' : null) : value,
          };
        })
        ?.sort(() => this.compareLabel),
    );
  }

  get multiOptions() {
    if (this.props.noModify) return this.props.options?.sort(this.compareLabel);
    if (this.props.name === 'status') {
      return this.props.options?.map((option, code) => ({ label: option, value: code + '' }))?.sort(this.compareLabel);
    }
    if (this.state.text) {
      return this.props.options
        ?.filter(option => option?.toLowerCase()?.includes(this.state.text.toLowerCase()))
        ?.map(option => ({ label: option, value: option.toLowerCase() }))
        ?.sort(this.compareLabel);
    }
    return [{ label: `${this.lblStr('company.filter.empty')}`, value: '-' }].concat(
      this.props.options
        ?.map(option => {
          return { label: this.lblStr(`${option}`), value: option.toLowerCase() };
        })
        ?.sort(this.compareLabel),
    );
  }

  get value() {
    return this.options.find(o => o.value === this.props.filterSingleValue);
  }

  toggleViewOptions = () => {
    this.setState(state => ({ showOptions: !state.showOptions }));
  };

  toggleAltFilters = value => {
    if (value == 1) {
      this.setState({ selectedValue: '1', altValue: '0', selectedLabel: 'yes' });
    } else if (value == 0) {
      this.setState({ selectedValue: '0', altValue: '1', selectedLabel: 'no' });
    } else if (value == null) {
      this.setState({ selectedValue: '0', altValue: '0', selectedLabel: '' });
    }
  };

  handleSetUser(user) {
    this.setState({
      selectedValue: user.id,
      selectedLabel: `${getPropByName(user, 'name') || ''} ${getPropByName(user, 'surname') || ''}`,
    });
  }

  renderSingleFilter = () => {
    const handleChange = pair => {
      console.log(pair);
      return pair.value === null
        ? this.props.setState({ selectedValue: null, selectedLabel: '' })
        : this.props.altKey && this.props.isBool
        ? this.toggleAltFilters(pair.value)
        : this.setState({ selectedValue: pair.value, selectedLabel: pair.label });
    };

    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.label[0];

    if (this.props.userId) {
      selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value[0];
      if (this.props.workUser)
        return (
          <HBox style={{ height: '55px' }}>
            <Loader small />
          </HBox>
        );
      return (
        <SearchCompanyAndUser
          companyFilter
          homeCompanyId={'4'}
          value={selected}
          onSelect={value => this.handleSetUser(value)}
        />
      );
    }

    return (
     
        <SearchSelect
          minWidth={'100%'}
          maxWidth={'100%'}
          placeholder={this.props.label ?? this.lblStr(`company.filter.${this.props.name}`)}
          options={this.options}
          value={selected && { label: selected }}
          onChange={handleChange}
          className="filter"
        />
      
    );
  };

  toggleOption = (value, label, option) => {
    this.setState(state => {
      return {
        selectedValues: [...value],
        selectedLabels: [...label],
      };
    });
  };

  handleMultiselectSearch = e => {
    this.setState({ text: e.target.value, showOptions: !!e.target.value?.length });
  };

  renderMultipleFilter = () => {
    let isActiveButton = false;
    const label = this.props.label ?? this.lblStr(`company.filter.${this.props.name}`);
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name);
    let selectedResult = [];

    selected?.value?.map((val, index) => {
      selectedResult?.push({
        value: val,
        label: selected?.label[index],
      });
    });

    return (
  
        <SearchSelect
          isMulti
          closeMenuOnSelect={false}
          minWidth={'100%'}
          maxWidth={'100%'}
          value={selectedResult}
          onChange={e => {
            const values = e.map(item => item.value);
            const labels = e.map(item => item.label);
            this.toggleOption(values, labels);
          }}
          placeholder={label}
          options={this.multiOptions}
        />
      
    );
  };

  searchCompany = () => {
    const searchText = normalizeSearchString(this.state.text);
    if (!searchText) return;
    this.props.searchCompany(this.state.text, result =>
      this.setState({
        showOptions: true,
        options: result?.items
          ?.map(parseCompany)
          ?.filter(company => {
            let filtered =
              (company.id !== this.state.company?.id && company?.__search?.indexOf(searchText) > -1) ||
              company.__email_search.indexOf(searchText) > -1;

            if (this.props.changeLocation) {
              filtered = company.__search.indexOf(searchText) > -1 || company.__email_search.indexOf(searchText) > -1;
            }

            return filtered;
          })
          ?.map(c => ({
            label: c.company_type === 'company' ? c?.name : `${c?.name}${c?.surname ? ' ' + c?.surname : ''}`,
            value: c?.id + '',
          })),
      }),
    );
  };

  search = () => {
    this._t = this.timeout(this.searchCompany, 600, this._t);
  };

  selectSearchOption = option => {
    this.setState({ [this.props.search]: option?.value, searchLabel: option?.label, text: '', showOptions: false });
  };

  onStringChange = evt => {
    let text = evt.target.value;
    this.setState({ text });
    let debounced = _.debounce(this.search, 300, { maxWait: 1000 });
    debounced();
  };

  renderSingleSearchFilter = () => {
    const label = this.props.label ?? this.lblStr(`company.filter.${this.props.name}`);
    if (this.props.search === 'company') {
      return (
        <div ref={this.wrapperRef} style={{ position: 'relative', width: '230px' }}>
          
            <div style={{ backgroundColor: 'white', display: 'flex', gap: '5px', height: '36px', width: '100%' }}>
              <input
                name="text"
                className="form-control fw-lighter"
                onChange={this.onStringChange}
                value={this.state.text}
                placeholder={label}
                
              />
              {this.props.searching ? <ButtonComponent style={'ButtonSoftPrimaryShort'}>
              <Loader small /> 
            </ButtonComponent> : null}
            </div>
            {!!this.state.showOptions && (
              <DropdownOptions show={!!this.state.showOptions}>
                {this.state.options?.map((option, idx) => {
                  return (
                    <DropdownOption
                      isSelected={option.value === this.state[this.props.search]}
                      key={`${this.props.name}_${option?.value}`}
                      onClick={() => this.selectSearchOption(option)}
                    >
                      <span>{option?.label}</span>
                    </DropdownOption>
                  );
                })}
              </DropdownOptions>
            )}
         
        </div>
      );
    }
  };

  handleClickOutside = e => {
    if (!!this.wrapperRef && !this.wrapperRef?.current?.contains(e.target) && !!this.state.showOptions) {
      this.setState({ showOptions: false });
    }
  };

  render() {
    return (
      <Container minWidth={this.props.minWidth} controlWidth={this.props.controlWidth}>
        {this.props.type === 'single' && !this.props.search && this.renderSingleFilter()}
        {this.props.type === 'multiple' && this.renderMultipleFilter()}
        {this.props.type === 'single' && this.props.search && this.renderSingleSearchFilter()}
      </Container>
    );
  }
}

CompanyFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  isBool: PropTypes.bool,
  altKey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectCompanyFilter(),
    filterSingleValue: selectFilterSingleValue(ownProps.name),
    values: selectFilterValues(ownProps.name),
    searching: selectWork(REQUEST_COMPANIES_SEARCH),
    workUser: selectWork(REQUEST_USER),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(alt = false) {
      dispatch(
        updateCompanyFilter(null, {
          reset: alt ? ownProps.altKey : ownProps.name,
        }),
      );
    },
    changeValues(values, labels = [], additionalName = null) {
      if (ownProps.inversed) {
        let inversed = values[0] === '1' ? false : true;
        let value = ['1'];
        dispatch(
          updateCompanyFilter({
            key: additionalName || ownProps.name,
            value: value,
            label: labels,
            type: ownProps.type,
            inversed: inversed,
          }),
        );

        return;
      }

      dispatch(
        updateCompanyFilter({
          key: additionalName || ownProps.name,
          value: values,
          label: labels,
          type: ownProps.type,
        }),
      );
    },
    change(value, key, label = '') {
      dispatch(
        updateCompanyFilter({
          key: key,
          value: [value.toString().toLowerCase()],
          label: [label],
          type: ownProps.type,
        }),
      );
    },
    searchCompany(text, callback) {
      dispatch(companySearch(text, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyFilter = compose(withConnect, withRouter, injectIntl)(CompanyFilterComp);
